export default {
    MIN_CONTAINER_HEIGHT_DESKTOP: 560
};
